import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 5 * 60 * 1000, // 5 minutes
    exclude: { query: false }
  }
}

const END_POINT = '/hotspots';

const loadHotSpots = async (location_id) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?location_id=${location_id}`,
    options
  );
}

export {
  loadHotSpots
}
